import React from 'react';
import { Box } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormDateInput } from '~/components/FormComponents/FormDateInput.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FinancialConditionSection } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionSection.tsx';
import type { TIncomeStructureByKvedFormValues } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/incomeStructureByKved/types.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

interface IIncomeStructureByKvedGeneralInfoSectionProps {
  disabled: boolean;
}

export const IncomeStructureByKvedGeneralInfoSection: React.FC<
  IIncomeStructureByKvedGeneralInfoSectionProps
> = ({ disabled }) => {
  const { control } = useFormContext<TIncomeStructureByKvedFormValues>();
  const soleProprietor = useWatch({ control, name: 'soleProprietor' });

  return (
    <FinancialConditionSection title="Загальні відомості">
      <Box sx={documentGenerationFormStyles.fieldsGrid}>
        <FormInput
          name="borrowerFullName"
          label="Повне найменування / ПІБ позичальника"
          disabled
          fullWidth
        />
        <FormInput
          name="borrowerIdentifier"
          label="ЄДРПОУ / РНОКПП / ІПН"
          disabled
          fullWidth
        />
        <FormInput
          name="soleProprietor"
          label="Тип позичальника"
          value={soleProprietor ? 'Фізична особа-підприємець (ФОП)' : 'Юридична особа'}
          disabled
          fullWidth
        />
        <FormInput name="reportYear" label="Звітний рік" disabled fullWidth />
        <FormDateInput name="documentDate" label="Дата довідки" disabled={disabled} />
      </Box>
    </FinancialConditionSection>
  );
};
